import { render, staticRenderFns } from "./PendingLineups.vue?vue&type=template&id=120b83eb&scoped=true&"
import script from "./PendingLineups.vue?vue&type=script&lang=js&"
export * from "./PendingLineups.vue?vue&type=script&lang=js&"
import style0 from "./PendingLineups.vue?vue&type=style&index=0&id=120b83eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b83eb",
  null
  
)

export default component.exports